import { render, staticRenderFns } from "./screening-task-content.vue?vue&type=template&id=938cf16a&scoped=true"
import script from "./screening-task-content.vue?vue&type=script&lang=js"
export * from "./screening-task-content.vue?vue&type=script&lang=js"
import style0 from "./screening-task-content.vue?vue&type=style&index=0&id=938cf16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938cf16a",
  null
  
)

export default component.exports